// src/features/suppliers/pages/SuppliersPage.js
import React from 'react';
import MasterDataListPage from '../../master-data/pages/MasterDataListPage';

const SuppliersPage = () => {
  return <MasterDataListPage type="suppliers" />;
};

export default SuppliersPage;